import React from "react";
import PanelSidebar from "../PanelSidebar";

export interface ConversationSummary {
    sessionId: string;
    title: string | null;
    updatedAt: string;
}

interface ChatHistorySidebarProps {
    open: boolean;
    sessionId: string;
    conversations: ConversationSummary[];
    groupedConvos: Record<string, ConversationSummary[]>;
    groupOrder: readonly string[];
    onNewChat: () => void;
    onSelect: (sessionId: string) => void;
    onDelete: (event: React.MouseEvent<HTMLButtonElement>, sessionId: string) => void;
}

export default function ChatHistorySidebar({
    open,
    sessionId,
    conversations,
    groupedConvos,
    groupOrder,
    onNewChat,
    onSelect,
    onDelete,
}: ChatHistorySidebarProps) {
    return (
        <PanelSidebar open={open} ariaLabel="Chat history">
            <PanelSidebar.Header title="Conversations">
                <PanelSidebar.Action onClick={onNewChat}>+ New Chat</PanelSidebar.Action>
            </PanelSidebar.Header>

            <PanelSidebar.Body>
                {conversations.length === 0 && (
                    <PanelSidebar.Empty>
                        <p>Your conversations will appear here once you start chatting.</p>
                    </PanelSidebar.Empty>
                )}

                {groupOrder.map(
                    (group) =>
                        groupedConvos[group] && (
                            <PanelSidebar.Group key={group} label={group}>
                                {groupedConvos[group].map((conversation) => (
                                    <PanelSidebar.Item
                                        key={conversation.sessionId}
                                        active={conversation.sessionId === sessionId}
                                        onClick={() => onSelect(conversation.sessionId)}
                                        onDelete={(event) => onDelete(event, conversation.sessionId)}
                                        deleteLabel="Delete conversation"
                                        icon={<ChatIcon />}
                                    >
                                        {conversation.title || "Untitled"}
                                    </PanelSidebar.Item>
                                ))}
                            </PanelSidebar.Group>
                        ),
                )}
            </PanelSidebar.Body>
        </PanelSidebar>
    );
}

const ChatIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
    </svg>
);
